<template>
  <page-outline :title="$t('common.entity_account.entity_account_details_file')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="listItemsEntityAccountFile.length > 0">
          <div>
            <form-accordion :title="$t('common.entity_account.details')" :isTitleUpperCase="false">
              <b-row class="form-group">
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].DateStartImport !== ''"
                    :inputLabel="$t('common.entity_account.date_start_import')" :inputValue="getDate(listItemsEntityAccountFile[0].DateStartImport)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.date_start_import')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input
                    :inputLabel="$t('common.entity_account.processing_time')"
                    :inputValue="processingDuration">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].FileName !== ''"
                    :inputLabel="$t('common.entity_account.file_name')" :inputValue="listItemsEntityAccountFile[0].FileName">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.file_name')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].FileReference !== ''"
                    :inputLabel="$t('common.entity_account.file_reference')" :inputValue="listItemsEntityAccountFile[0].FileReference">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.file_reference')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].Bic !== ''"
                    :inputLabel="$t('common.entity_account.bic')" :inputValue="listItemsEntityAccountFile[0].Bic">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.bic')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].Status !== ''"
                    :inputLabel="$t('common.entity_account.file_status')" :inputValue="$t('common.entity_account.file_status_' + listItemsEntityAccountFile[0].Status)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.file_status')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].SynchroType !== ''"
                    :inputLabel="$t('common.entity_account.synchro_type')" :inputValue="$t('common.entity_account.synchro_type_' + listItemsEntityAccountFile[0].SynchroType)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.synchro_type')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].ImportResult !== ''"
                    :inputLabel="$t('common.entity_account.import_result')" :inputValue="$t('common.entity_account.import_result_' + listItemsEntityAccountFile[0].ImportResult)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('common.entity_account.import_result')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <!-- <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="listItemsEntityAccountFile[0].IdTechnical !== ''"
                    :inputLabel="$t('common.entity_account.technical_file_id')" :inputValue="listItemsEntityAccountFile[0].IdTechnical">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input
                    v-if="listItemsEntityAccountFile[0].Length !== ''"
                    :inputLabel="$t('common.entity_account.file_size')"
                    :inputValue="listItemsEntityAccountFile[0].Length + ' ' +
                      $t('common.entity_account.' + (listItemsEntityAccountFile[0].Length <= 1 ? 'byte' : 'bytes'))">
                  </form-read-group-label-input>
                </b-col> -->
              </b-row>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('common.entity_account.file_history')" :isTitleUpperCase="false">
              <table class="table table-striped w-50" style="margin: 0 auto" v-if="listItemsEntityAccountFileHistory.length > 0">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.date_action') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.file_status') }}
                  </th>
                </tr>
                <tr v-for="his in listItemsEntityAccountFileHistory" :key="listItemsEntityAccountFileHistory.IdEntityAccountFile">
                  <td class="text-center w-25">
                    <div v-if="his.DateAction !== ''">{{ getDate(his.DateAction) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="his.Status !== ''">{{ $t('common.entity_account.file_status_' + his.Status) }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </form-accordion>
          </div>
          <!-- <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('common.entity_account.entity_account_history')" :isTitleUpperCase="false">
              <table class="table table-striped" v-if="listItemsEntityAccount.length > 0">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.date_action') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.iban_encrypted') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.iban_reference') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('common.entity_account.iban_import_status') }}
                  </th>
                </tr>
                <tr v-for="iban in listItemsEntityAccount" :key="listItemsEntityAccount.IdEntityAccountFile">
                  <td class="text-center w-25">
                    <div v-if="iban.DateAction !== ''">{{ getDate(iban.DateAction) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="iban.IbanEncrypted !== ''">{{ iban.IbanEncrypted }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="iban.IbanReference !== ''">{{ iban.IbanReference }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div v-if="iban.StatusImportIban !== ''">{{ $t('common.entity_account.iban_import_status_' + iban.StatusImportIban) }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </form-accordion>
          </div> -->

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue"
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import {errorMessageAlert} from "@/helpers/alert"
import moment from "moment"

export default {
  name: 'EntityAccountFileDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  data () {
    return {
      activateSpinner: false,
      listItemsEntityAccount: [],
      listItemsEntityAccountFile: [],
      listItemsEntityAccountFileHistory: [],
      returnUrl: ''
    }
  },
  created () {
    this.IdEntityAccountFile = this.$route.params.idEntityAccountFile

    const queryParams = this.$route.query
    const queryString = new URLSearchParams(queryParams).toString()
    this.returnUrl = '/entityAccountPage/EntityAccountFile?' + queryString

    this.getEntityAccount()
    this.getEntityAccountFile()
    this.getEntityAccountFileHistory()

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$t('common.entity_account.entity_account_details'),
    })

    this.$f7.initPullToRefresh()
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  computed: {
    processingDuration() {
      return this.calculateProcessingDuration(this.listItemsEntityAccountFileHistory)
    }
  },
  methods: {
    calculateDuration(start, end) {
      if (!start || !end) return '-'

      const startDate = new Date(start)
      const endDate = new Date(end)
      const diffMs = endDate - startDate

      // if (diffMs < 0) return '-'

      const seconds = Math.floor((diffMs / 1000) % 60)
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60)
      const hours = Math.floor(diffMs / (1000 * 60 * 60))

      let duration = ''
      if (hours > 0) {
        duration += `${hours}h `
      }
      if (minutes > 0) {
        duration += `${minutes}m `
      }
      if (seconds > 0) {
        duration += `${seconds}s`
      }
      if (hours === 0 && minutes === 0 && seconds === 0) {
        return "< 1s"
      }

      return duration.trim()
    },
    calculateProcessingDuration(history) {
      if (!history || history.length === 0) return '-'

      // Trier l'historique par date croissante
      const sortedHistory = history.sort((a, b) => new Date(a.DateAction) - new Date(b.DateAction))

      // Trouver la date du statut 2
      const startEntry = sortedHistory.find(entry => entry.Status === "2")
      if (!startEntry) return '-'

      const startDate = new Date(startEntry.DateAction)

      // Trouver la première occurrence du statut 3 ou 4 après le statut 2
      const endEntry = sortedHistory.find(entry =>
        (entry.Status === "3" || entry.Status === "4") && new Date(entry.DateAction) >= startDate
      )

      if (!endEntry) return '-'

      const endDate = new Date(endEntry.DateAction)

      return this.calculateDuration(startDate, endDate)
    },
    getEntityAccount() {
      let that = this
      let params = {
        IdEntityAccountFile: this.IdEntityAccountFile
      }

      this.$engine.entityAccount.getEntityAccount(params).then((resp) => {

        let EntityAccountList = {}

        EntityAccountList = resp.data.EntityAccount

        that.updateEntityAccount(EntityAccountList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getEntityAccountFile() {
      let that = this
      let params = {
        IdEntityAccountFile: this.IdEntityAccountFile
      }
      this.$engine.entityAccount.getEntityAccountFile(params).then((resp) => {
        let EntityAccountFileList = {}

        EntityAccountFileList = resp.data.EntityAccountFile

        that.updateEntityAccountFile(EntityAccountFileList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getEntityAccountFileHistory() {
      let that = this
      let params = {
        IdEntityAccountFile: this.IdEntityAccountFile
      }

      this.$engine.entityAccount.getEntityAccountFileHistory(params).then((resp) => {

        let EntityAccountFileHistoryList = {}

        EntityAccountFileHistoryList = resp.data.EntityAccountFileHistory

        that.updateEntityAccountFileHistory(EntityAccountFileHistoryList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
      }
      else {
        return '-'
      }
    },
    updateEntityAccount(EntityAccountList) {
      this.listItemsEntityAccount = EntityAccountList
    },
    updateEntityAccountFile(EntityAccountFileList) {
      this.listItemsEntityAccountFile = EntityAccountFileList
    },
    updateEntityAccountFileHistory(EntityAccountFileHistoryList) {
      this.listItemsEntityAccountFileHistory = EntityAccountFileHistoryList
    }
  }
}
</script>
